<template>
    <div id="generator_contentText">
        <div class="generator_title">{{ templateItem.paramName }}</div>
        <div class="generator_contentText" v-if="templateItem.paramType === 'length'">
            <el-input v-model="content" type="number" :placeholder="placeholder" show-word-limit
                @input="getText"></el-input>
            <!-- <div class="generator_contentText1">
                <div  class="generator_contentText1_1">
                    <img v-if="delIcon" src="../assets/image/icon_del.png" alt="">
                </div>
                <div class="generator_contentText1_2">{{ content.length }}/{{numLength}}</div>
            </div> -->
        </div>
        <div class="generator_contentText" v-else>
            <el-input v-model="content" type="textarea" :maxlength="maxlength" :autosize="{ minRows: 3, maxRows: 8 }"
                :placeholder="templateItem.placeholder" @input="getText"></el-input>
            <div class="generator_contentText1">
                <div class="generator_contentText1_1 cursor_1" @click="clearTextClick">
                    <img src="../assets/image/icon_del.png" alt="">
                </div>
                <div class="generator_contentText1_2">{{ content.length }}/{{ maxlength }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        templateItem: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            content: "",
            numLength: this.templateItem.paramType === 'length' && this.templateItem.placeholder ? this.templateItem.placeholder.length : 300,
            placeholder: this.templateItem.paramType === 'length' && this.templateItem.placeholder ? `请输入数字(<=${this.templateItem.placeholder})` : "请输入数字",
            maxlength: this.templateItem.maxLength ? this.templateItem.maxLength : this.templateItem.paramType == 'text' ? 300 : 10000, //最大输入字数
            delIcon: this.templateItem.paramType == 'text' ? false : true, //显示删除图标
        }

    },
    methods: {
        getText() {
            this.$emit('getText', this.templateItem, this.content)
        },
        clearTextClick() {
            this.content = ''
        }
    }
}
</script>
<style lang="scss">
#generator_contentText {
    margin-bottom: 15px;
}

.generator_title {
    font-size: 16px;
    color: #0D0D0D;
    margin-bottom: 15px;
}

.generator_contentText {
    width: 100%;
    background: #F8F8F8;
    box-shadow: inset 0px 0 4px 0px rgba(255, 255, 255, 0.2);
    border-radius: 8px;
}

.generator_contentText .el-textarea__inner {
    width: 100%;
    background-color: #F8F8F8;
    resize: none;
    font-size: 15px;
    border: none;
}

.generator_contentText1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
}

.generator_contentText1_1 {
    display: flex;
}

.generator_contentText1_1 img {
    width: 16px;
}

.generator_contentText1_2 {
    font-size: 12px;
    color: #444444;
}
</style>